import styles from "./NotFound.module.css";

export const NotFound = () => {
  return <div className={styles["not-found__container"]}>Bad GateWay</div>;
};
